module.exports = __webpack_public_path__ + "img/telegram-logo.6f75526e.svg";